import { render, staticRenderFns } from "./create-service-request.vue?vue&type=template&id=10434670&"
import script from "./create-service-request.vue?vue&type=script&lang=js&"
export * from "./create-service-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports